import axios from "axios";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";
import type { LoginData } from "../types/auth.types";

/** Standard PK-Soft response envelope. */
export interface ApiEnvelope<T = unknown> {
  status?: number;
  messageCode?: number;
  message?: string;
  data?: T;
}

export interface RegisterV2Payload {
  name: string;
  emailId: string;
  mobile: string;
  postingDate: string;
  password: string;
  confirmPassword: string;
}

export interface VerifyRegisterOtpV2Payload {
  emailId: string;
  /** Token returned in `data.token` by the v2 register call. */
  token: string;
  otpCode: string;
  postingDate: string;
}

export interface LoginResponseData {
  token?: string;
  pksoft_token?: string;
  userModel?: { code?: string; name?: string; [key: string]: unknown };
}

/** POST v2/register — creates the account and emails an OTP; `data.token` identifies it. */
export const registerV2API = async (payload: RegisterV2Payload) => {
  const response = await axios.post<ApiEnvelope<{ token?: string }>>(
    PKSOFT_URLS.CUSTOMER.REGISTER_V2,
    payload,
  );
  return response.data;
};

/** POST v2/verify-otp — confirms the emailed OTP for a v2 registration. */
export const verifyRegisterOtpV2API = async (payload: VerifyRegisterOtpV2Payload) => {
  const response = await axios.post<ApiEnvelope>(
    PKSOFT_URLS.CUSTOMER.REGISTER_OTP_V2,
    payload,
  );
  return response.data;
};

/** POST auth — `username` is the account's email address. */
export const loginAPI = async (credentials: LoginData) => {
  const response = await axios.post<ApiEnvelope<LoginResponseData>>(
    PKSOFT_URLS.CUSTOMER.LOGIN,
    credentials,
  );
  return response.data;
};
